<template>
  <div
    class="bg-white shadow-md rounded flex flex-col p-1 sm:p-2 md:p-2 lg:p-4 xl:p-4"
  >
    <div class="text-5xl text-gray-800 leading-10">
      <div class="text-sm leading-5">Conteggio</div>
      <div
        v-bind:class="{
          'text-red-700': gameCounter >= 10 || gameCounter <= -10
        }"
      >
        {{ gameCounter }}
      </div>
    </div>

    <div class="text-xs md:text-md border-t-2 border-gray-600">
      Carte disponibili
    </div>
    <div class="text-2xl leading-tight text-green-500">
      {{ availableCards.length }} / {{ totalCards }}
    </div>
  </div>
</template>

<script>
import store from "../store";

export default {
  name: "Counter",
  store,

  computed: {
    gameCounter() {
      return this.$store.getters.shoe.hiLoRunningCount;
    },
    availableCards() {
      return this.$store.getters.getAvailableCards;
    },

    totalCards() {
      return this.$store.getters.getMaxCards;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Counter.vue